import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import OwnerSidebar from "./OwnerSidebar";
import OwnerTopBar from "./OwnerTopBar";
import OwnerBreadcrumbs from "./OwnerBreadcrumbs";
import { OwnerShellProvider, useOwnerShell } from "./OwnerShellContext";
import "./tokens.css";
import "./layout.css";
import "./cards.css";
import "./primitives.css";
import "./primitives-p1.css";
import "./primitives-p2.css";
import "./templates/templates.css";
import "./global-polish.css";
import "./gate-2-5-polish.css";
import { ConfirmProvider } from "./primitives/Confirm";
import { ToastProvider } from "./primitives/Toast";

/**
 * Dark shell for the Platform Owner Console.
 *
 *   ┌────────────┬─────────────────────────────────────────┐
 *   │ Brand      │  TopBar  (search · env · actions · me)  │
 *   │ ---------- ├─────────────────────────────────────────┤
 *   │  scroll ↕  │  Breadcrumbs                            │
 *   │  Groups:   ├─────────────────────────────────────────┤
 *   │   Platform │                                         │
 *   │   Ops      │   <Outlet /> — scrolls independently    │
 *   │   Infra    │                                         │
 *   │ ---------- │                                         │
 *   │  Collapse  │                                         │
 *   └────────────┴─────────────────────────────────────────┘
 *
 * Sidebar collapse + group-expansion preferences persist in localStorage.
 */
function ShellInner() {
  const { collapsed } = useOwnerShell();
  useEffect(() => {
    const b = document.body;
    b.classList.add("hbf-owner");
    return () => b.classList.remove("hbf-owner");
  }, []);
  useEffect(() => {
    const b = document.body;
    if (collapsed) b.classList.add("is-sidebar-collapsed");
    else           b.classList.remove("is-sidebar-collapsed");
    return () => b.classList.remove("is-sidebar-collapsed");
  }, [collapsed]);

  return (
    <div
      className={`hbf-owner__root ${collapsed ? "is-collapsed" : ""}`}
      data-testid="owner-layout"
    >
      <div className="hbf-owner__grain" aria-hidden />
      <OwnerSidebar />
      <div className="hbf-owner__main">
        <OwnerTopBar />
        <OwnerBreadcrumbs />
        <main className="hbf-owner__content" data-testid="owner-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default function OwnerLayout() {
  return (
    <OwnerShellProvider>
      <ConfirmProvider>
        <ToastProvider>
          <ShellInner />
        </ToastProvider>
      </ConfirmProvider>
    </OwnerShellProvider>
  );
}
